/**
 * The side menu's show / hide icon (Gary, 18 Oct): a panel with its left side marked, the same icon as the
 * chat list's in CMB Chats, so both apps read the same. Takes its colour from the button.
 */
export function PanelIcon() {
  return (
    <svg className="sidebar-toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M9 4v16" />
    </svg>
  );
}
